import React from 'react';
import { motion } from 'framer-motion';
import Countdown from './Countdown';

const Hero = () => {
  return (
    <section className="relative min-h-[90vh] flex flex-col justify-end pb-20 pt-32 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto border-b border-[#333]">
      <div className="absolute inset-0 z-[-1] overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent z-10" />
        <img 
          src="https://images.unsplash.com/photo-1552346154-21d32810baa3?q=80&w=2000&auto=format&fit=crop" 
          alt="Sneaker background" 
          className="w-full h-full object-cover opacity-30 grayscale"
        />
      </div>

      <div className="z-10 w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-block bg-acid px-3 py-1 text-black font-bold text-sm tracking-widest mb-6 uppercase">
            Drop 001 — Live Now
          </div>
          <h1 className="heading-brutal text-6xl sm:text-8xl md:text-[10rem] text-white mb-8">
            CONCRETE<br />
            <span className="text-transparent stroke-text" style={{ WebkitTextStroke: '2px #737373' }}>JUNGLE</span>
          </h1>
          
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mt-12">
            <div>
              <p className="text-[#737373] max-w-md text-lg uppercase font-bold tracking-wide mb-6">
                Limited to 500 pairs worldwide. No restocks. Secure your size before the clock runs out.
              </p>
              <Countdown />
            </div>
            
            <a href="#drop" className="bg-white text-black px-8 py-5 text-xl font-black uppercase tracking-tight hover:bg-acid transition-colors text-center">
              Enter The Drop
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;